import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { triggerFormValidation, focusFirstInvalidField } from '@app/base/shared';
import { ConstantsService, SessionService, EnvironmentService, RequestStageLabelEnum,  LookupsService } from '@app/base/core';
import { LandingService } from '@app/modules/landing/base';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { AlertService } from '@app/base/alerts/alert.service';
import { Subscription } from 'rxjs';
import { BuilderService } from '@app/modules/builder';
import { DatePipe } from '@angular/common';

const moment = require('moment');
require('moment-weekday-calc');

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-contractAccept',
  templateUrl: './contractAccept.component.html',
  styleUrls: ['./contractAccept.component.css']
})
export class AcceptContractComponent implements OnInit, OnDestroy , AfterViewInit {
  constructor( private route: ActivatedRoute,
    private router: Router,
    private http: LandingService,
    private datePipe: DatePipe,
    public sessionSvc: SessionService,
    public lookupSvc: LookupsService,
    public alertService: AlertService,
    public constantsSvc: ConstantsService,
    public config: SocoConfigurationService,
    public environmentSvc: EnvironmentService,
    public builderSvc: BuilderService ) {this.buildFormGroup(); }
    public routeSubscription: any;
    public bcaContractSubscription: Subscription;
  @ViewChild('btnPayment', {static: false}) btnP: ElementRef;
  @ViewChild('btnAccept', {static: false}) btnA: ElementRef;
  @ViewChild('btnReject', {static: false}) btnR: ElementRef;
  @ViewChild('contractMessage', {static: false}) contractMessage: ElementRef;
  @ViewChild('contractacceptDv', {static: false}) contractacceptDv: ElementRef;
  @ViewChild('BcaDetails', {static: false}) BcaDetails: ElementRef;
  @ViewChild('witnesslabel', {static: false}) witnesslabel: ElementRef;
  alertMsg: any = [];
  stageLabelEnum: typeof RequestStageLabelEnum = RequestStageLabelEnum;
  BcaId: number;
  ContractInfo: string;
  contractAcceptForm: FormGroup;
  Status: string;
  message: string;
  projectName: string;
  user: string;
  public bcaData: any = [];
  public fileid: number;
  documentInput: any = {};
  public filesArr = [];
  public dateOptions: any = {
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    parentEl: '.dateClass',
    minDate: moment().addWorkdays(0),
    maxDate: moment().addWorkdays(0)
};
  buildFormGroup(): void {
    this.contractAcceptForm = new FormGroup({
      Id: new FormControl(null),
      ContractSignedByApplicant: new FormControl(null, [Validators.required, Validators.pattern(this.constantsSvc.spacePattern)]),
      ContractSignedByName: new FormControl(null, [Validators.required, Validators.pattern(this.constantsSvc.spacePattern)]),
      ContractSignedByTitle: new FormControl(null, [Validators.required, Validators.pattern(this.constantsSvc.spacePattern)]),
      ContractSignedDate: new FormControl(null, [Validators.required, Validators.pattern(this.constantsSvc.spacePattern),
      Validators.pattern(this.constantsSvc.dateValidator)]),
      Comments: new FormControl(null),
      Remarks: new FormControl(null, [Validators.required, Validators.pattern(this.constantsSvc.spacePattern)]),
      RejectionRemarks: new FormControl(null, [ Validators.pattern(this.constantsSvc.spacePattern)]),
      Status: new FormControl(null),
    },
    { updateOn: 'blur' }
    );
  }
  // To open Popup for Rejection Comments
  OpenPopUp() {
    if (this.contractAcceptForm.valid) {
    this.contractAcceptForm.controls['Comments'].setValidators([Validators.required]);
    this.contractAcceptForm.controls['RejectionRemarks'].setValidators(
      [Validators.required, Validators.pattern(this.constantsSvc.spacePattern)]);
      this.contractAcceptForm.controls['Comments'].updateValueAndValidity({
        onlySelf: true
        });
        this.contractAcceptForm.controls['RejectionRemarks'].updateValueAndValidity({
          onlySelf: true
          });
      this.contractAcceptForm.updateValueAndValidity();
      $('#modal_reject_contract').modal();
    } else {  triggerFormValidation(this.contractAcceptForm);
      focusFirstInvalidField(this.contractAcceptForm); }
  }
  // To Close Rejection comments Popup
  ClosePopUp() {
    this.contractAcceptForm.controls['Comments'].clearValidators();
    this.contractAcceptForm.controls['RejectionRemarks'].clearValidators();
      this.contractAcceptForm.updateValueAndValidity();
    $('#modal_reject_contract').modal('hide');
  }
  // To Accept/Reject Contract based on status
  AcceptRejectClick(status: string) {
if (status !== this.constantsSvc.rejected) {
  this.contractAcceptForm.controls['Comments'].clearValidators();
  this.contractAcceptForm.controls['RejectionRemarks'].clearValidators();
  this.contractAcceptForm.controls['Comments'].updateValueAndValidity({
    onlySelf: true
    });
    this.contractAcceptForm.controls['RejectionRemarks'].updateValueAndValidity({
      onlySelf: true
      });
    this.contractAcceptForm.updateValueAndValidity();
    }
    if (status === this.constantsSvc.PopUp) {
     this.OpenPopUp();
     return false;
    }
    if (this.contractAcceptForm.valid) {
      this.ClosePopUp();
      const formValue = this.contractAcceptForm.getRawValue();
      formValue.Id = this.BcaId;
      formValue.Comments =  status === this.constantsSvc.rejected ?  this.contractAcceptForm.controls['Comments'].value.itemName : '';
      formValue.Status = status ;
      formValue.RecUpdateDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      this.HideDiv();
      this.http.postGasContract(formValue).subscribe(result => {
        this.ClosePopUp();
if (status === this.constantsSvc.accepted) {
this.message = this.constantsSvc.contractAcceptMsg;
  if (this.btnP) {
    this.btnP.nativeElement.style.display = this.constantsSvc.block;
}
} else if (status === this.constantsSvc.rejected) {
  this.message = this.constantsSvc.contractRejectMsg;
  if (this.btnP ) {
    this.btnP.nativeElement.style.display = this.constantsSvc.none;
  }
}
if (this.contractMessage) {
  this.contractMessage.nativeElement.style.display = this.constantsSvc.block;
}
      }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });

    }    else {
        triggerFormValidation(this.contractAcceptForm);
        focusFirstInvalidField(this.contractAcceptForm);
    }

  }

  private HideDiv() {
    if (this.contractacceptDv) {
      this.contractacceptDv.nativeElement.style.display = this.constantsSvc.none;
      this.btnA.nativeElement.style.display = this.constantsSvc.none;
      this.btnR.nativeElement.style.display = this.constantsSvc.none;
      this.contractMessage.nativeElement.style.display = this.constantsSvc.none;
      this.BcaDetails.nativeElement.style.display = this.constantsSvc.none;
      this.witnesslabel.nativeElement.style.display = this.constantsSvc.none;
    }
  }

  ngOnInit() {
    this.user = this.constantsSvc.ApplicantUser;
    // Load common lookups
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // To Load banner messages
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Contract Accepted'));
        this.alertService.success(this.alertMsg.message);
      }
    });
 // Get status ID from route params.
 this.routeSubscription = this.route.params.subscribe(params => {
  if (params['id']) {
    this.BcaId = (params['id']);
  }
  if (params['requestType']) {
    this.ContractInfo = (params['requestType']);
  }
  });
   this.bcaContractSubscription = this.http.getBcaContractInfo(this.BcaId).subscribe(result => {
    if (result.data != null) {
      this.BcaId = result.data[0].bcaId;
      this.sessionSvc.projectName = result.data[0].projectName;
      this.Status = result.data[0].requestStatus;
      if (this.Status === this.constantsSvc.CONRCVD ) {
        this.HideDiv();
        this.message = this.constantsSvc.contractAcceptMsg;
        if (this.btnP) {
          this.btnP.nativeElement.style.display = this.constantsSvc.block;
          this.contractMessage.nativeElement.style.display = this.constantsSvc.block;
        }
      } else if (this.Status === this.constantsSvc.CONRJTD ) {
        this.HideDiv();
        this.message = this.constantsSvc.contractRejectMsg;
        if (this.btnP ) {
          this.btnP.nativeElement.style.display = this.constantsSvc.none;
          this.contractMessage.nativeElement.style.display = this.constantsSvc.block;
        }

      }
    }
  });
}
// To close popups and unsubscribe subscriptions
  ngOnDestroy() {
   this.ClosePopUp();
   this.routeSubscription.unsubscribe();
   if (this.bcaContractSubscription) {
     this.bcaContractSubscription.unsubscribe();
   }
  }
  // go to contract page
  goToBack() {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(),  'builder', 'contract',
      this.sessionSvc.sourceToContract, this.BcaId]);
  }
  // go To Payment page
  goToPayment() {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(),
        'builder', 'payment', this.sessionSvc.sourceToContract, this.BcaId]);
  }
  ngAfterViewInit(): void {
    if (this.btnP) {
      this.btnP.nativeElement.style.display = this.constantsSvc.none;
    }
  }
  downloadDoc(docType) {
    this.filesArr = [];
    this.documentInput.documentType = docType;
    this.documentInput.folder = this.constantsSvc.LaserficheContractFolder;
    this.builderSvc.findFilesByMetadata(this.documentInput).subscribe(result => {
      if (result.data.length !== 0) {
        for ( let i = 0; i < result.data.length; i++) {
            this.filesArr.push(result.data[i]);
        }
        const recentdate = new Date(Math.max.apply(null, this.filesArr.map(function(e) {
          return new Date(e.creationDate);
        })));
        const mostRecentObject = this.filesArr.filter( e => {
          const d = new Date( e.creationDate );
          return d.getTime() === recentdate.getTime();
      })[0];
        this.fileid = mostRecentObject.id;
        window.open(this.config.webApiBaseUrl + '/Files/Download?id=' + this.fileid, '_blank');
      } else {
        swal(this.constantsSvc.headerDocReqSwal, this.constantsSvc.contractDocFailSwal, this.constantsSvc.errorSwal);
      }
    },
    (error) => {
      swal(this.constantsSvc.headerDocReqSwal, this.constantsSvc.contractDocFailSwal, this.constantsSvc.errorSwal);
    });
    }
}
